import GOOGLEMAP from '../plugins/googlemap'

const [w,d,host] = [window,document,location.host]

export default function CONCEPT() {
  // map script
  const km = w.siteinfo.mapApiKeys
  const env_map_key = (!km[host]) ? km['local'] : km[host]
  w.addScript({src:`https://maps.googleapis.com/maps/api/js?v=3&key=${env_map_key}&callback=load.mapScript.resolve`})

  // map
  d.addEventListener( 'DOMContentLoaded', () => {
    w.load['mapScript'].done( () => GOOGLEMAP( { markers:
      [
        {
          title: 'こころね',
          latlng: '34.7403436,137.7411707',
          address: '〒433-8122<br>静岡県浜松市中区上島2-13-62',
          icon: '/asset/img/top/map_peg_kamijima.png',
          iconSize: '100,48',
        },
        {
          title: 'こころね三方原',
          latlng: '34.7752332,137.7296854',
          address: '〒433-8104<br>静岡県浜松市北区東三方町28-3',
          icon: '/asset/img/top/map_peg_mikatabara.png',
          iconSize: '100,48',
        },
        {
          title: 'こころね浜北・あえる浜北',
          latlng: '34.8045346,137.800712',
          address: '〒434-0026<br>静岡県浜松市浜北区東美薗1571-1',
          icon: '/asset/img/top/map_peg_hamakita.png?ts=20201022',
          iconSize: '178,47',
        }
      ]
    } ) )
  } )
}